export const oneYearPricedDefaultLocations = [
  '/screens/landing/location',
  '/screens/landing/investors',
  '/screens/landing/industry',
  '/screens/landing/underwriter',
];
export const allUpcomingDefaultLocations = ['LocationLanding', 'InvestorsLanding'];
export const fiveYearUpcomingDefaultLocations = ['IndustryLanding', 'UnderwriterLanding'];
